import * as Scrivito from "scrivito";

import { baseUrlForSite, siteForUrl } from "./multisite";

const config = {
  endpoint: process.env.SCRIVITO_ENDPOINT || "https://api.scrivito.com/v1",
  instanceId: process.env.SCRIVITO_TENANT,
  visitorAuthentication: getVisitorAuthentication(),
  adoptUi: true,
  autoConvertAttributes: true,
  optimizedWidgetLoading: true,
  strictSearchOperators: true,
  baseUrlForSite,
  siteForUrl,
};

export default function configureScrivito(options) {
  const priority = options?.priority;
  Scrivito.configure(priority ? { ...config, priority } : config);
}

function getVisitorAuthentication() {
  if (typeof document !== "undefined") {
    return window.localStorage.getItem("keycloakLoginPresent") === "loggedIn";
  }
  return false;
}
